<template>
  <page-header-wrapper>
    <a-card>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" class="table-head-ground">
          <div class="table-layer">
            <!-- 时间筛选器 -->
            <a-form-item label="" style="max-width: 520px; min-width:400px">
              <time-range-filter
                ref="timeRangeFilter"
                :default-type="'today'"
                @change="handleTimeRangeChange"
              />
            </a-form-item>
<!--            <a-form-item label="">-->
<!--              <jeepay-text-up :placeholder="'商户ID'" :msg="searchData.mchNo" v-model="searchData.mchNo"/>-->
<!--            </a-form-item>-->
            <!-- <jeepay-text-up :placeholder="'应用AppId'" :msg="searchData.appId" v-model="searchData.appId"/>
            <jeepay-text-up :placeholder="'应用名称'" :msg="searchData.appName" v-model="searchData.appName"/> -->
            <a-form-item label="">
              <a-select v-model="searchData.status" placeholder="状态" default-value="" style="width: 150px">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="1">成功</a-select-option>
                <a-select-option value="2">失败</a-select-option>
                <a-select-option value="3">处理中</a-select-option>
              </a-select>
            </a-form-item>
            <span class="table-page-search-submitButtons" style="flex-grow: 0; flex-shrink: 0;">
              <a-button type="primary" icon="search" @click="queryFunc" :loading="btnLoading">查询</a-button>
              <a-button style="margin-left: 8px" icon="reload" @click="resetForm">重置</a-button>
            </span>
          </div>
        </a-form>
      </div>

      <!-- 列表渲染 -->
      <JeepayTable
        @btnLoadClose="btnLoading=false"
        ref="infoTable"
        :initData="false"
        :reqTableDataFunc="reqTableDataFunc"
        :tableColumns="tableColumns"
        :searchData="searchData"
        rowKey="appId"
      >
        <template slot="appIdSlot" slot-scope="{record}">
          <b>{{ record.appId }}</b>
        </template> <!-- 自定义插槽 -->
        <template slot="stateSlot" slot-scope="{record}">
          <!-- 三个状态 1 成功 2 失败 3 处理中 -->
          <a-tag v-if="record.status === 1" color="green">成功</a-tag>
          <a-tag v-else-if="record.status === 2" color="red">失败</a-tag>
          <a-tag v-else-if="record.status === 3" color="orange">处理中</a-tag>
          <a-tag v-else color="orange">未知</a-tag>
          <!-- <a-badge :status="record.state === 1 ?'error':'processing'" :text="record.status === 1?'chen z':'启用'" /> -->
        </template>
        <template slot="createAtSlot" slot-scope="{record}">
          {{ formateDate(record) }}
        </template>
        <template slot="balanceAfterRechargeSlot" slot-scope="{record}">
          {{ formateBalance(record) }}
        </template>
        <template slot="rechargeAmountSlot" slot-scope="{record}">
          {{ formateBalance(record) }}
        </template>
      </JeepayTable>
    </a-card>
    <!-- 新增应用  -->
    <!-- <MchAppAddOrEdit ref="mchAppAddOrEdit" :callbackFunc="searchFunc"/> -->
    <!-- 支付参数配置页面组件  -->
    <!-- <MchPayIfConfigList ref="mchPayIfConfigList" /> -->
  </page-header-wrapper>
</template>
<script>
  import moment from 'moment'
  import JeepayTable from '@/components/JeepayTable/JeepayTable'
import JeepayTextUp from '@/components/JeepayTextUp/JeepayTextUp' // 文字上移组件
import JeepayTableColumns from '@/components/JeepayTable/JeepayTableColumns'
import TimeRangeFilter from '@/components/TimeRangeFilter'
  import { API_URL_RECHARGE_ORDER_LIST, req } from '@/api/manage'
//   import MchAppAddOrEdit from './AddOrEdit'
//   import MchPayIfConfigList from './MchPayIfConfigList'
  // eslint-disable-next-line no-unused-vars
  const tableColumns = [
    // { key: 'appId', fixed: 'left', width: '320px', title: '应用AppId', scopedSlots: { customRender: 'appIdSlot' } },
    // { key: 'code', title: '应用名称', dataIndex: 'appName' },
    { key: 'mchNo', title: '商户ID', dataIndex: 'mchNo' },
    { key: 'rechargeAmount', title: '充值金额', dataIndex: 'rechargeAmount', scopedSlots: { customRender: 'rechargeAmountSlot' }, sorter: true },
    { key: 'balanceAfterRecharge', title: '余额', dataIndex: 'balanceAfterRecharge', scopedSlots: { customRender: 'balanceAfterRechargeSlot' }, sorter: true },
    { key: 'status', title: '状态', scopedSlots: { customRender: 'stateSlot' } },
    { key: 'createdAt', dataIndex: 'createdAt', title: '创建时间', scopedSlots: { customRender: 'createAtSlot' } },
     // 单位是分
     { key: 'createdBy', title: '创建者姓名', dataIndex: 'createdBy' }
    // { key: 'op', title: '操作', width: '260px', fixed: 'right', align: 'center', scopedSlots: { customRender: 'opSlot' } }
  ]
  export default {
  name: 'RechargeOrderListPage',
  components: { JeepayTable, JeepayTableColumns, JeepayTextUp, TimeRangeFilter },
    data () {
      return {
        btnLoading: false,
        tableColumns: tableColumns,
        searchData: { 'mchNo': '', 'status': '' }
      }
    },
    mounted () {
      this.searchData.mchNo = this.$route.query.mchNo
      this.queryFunc()
    },
    methods: {
      // 处理时间范围变化
      handleTimeRangeChange (timeData) {
        this.searchData.createdStart = timeData.startTime
        this.searchData.createdEnd = timeData.endTime
      },

      queryFunc () {
        this.btnLoading = true
        this.$refs.infoTable.refTable(true)
      },
      // 请求table接口数据
      reqTableDataFunc: (params) => {
        return req.list(API_URL_RECHARGE_ORDER_LIST, params)
      },
      searchFunc: function () { // 点击【查询】按钮点击事件
        this.$refs.infoTable.refTable(true)
      },
      formateDate: function (date) {
        // console.log('date》〉》〉', date)
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
      // 分转元
      formateBalance: function (balance) {
        return '₹ ' + (balance).toFixed(2)
      },

      resetForm () {
        this.$set(this.searchData, 'mchNo', null)
        this.$set(this.searchData, 'createdStart', null)
        this.$set(this.searchData, 'createdEnd', null)
        delete this.searchData.status
        this.$nextTick(() => {
          if (this.$refs.timeRangeFilter) {
            this.$refs.timeRangeFilter.resetToDefault()
          }
          this.searchFunc()
        })
      }
    }
  }
</script>
<style lang="less" scoped>
</style>
